import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import "./style.css";
import { validateUploadedFile } from "../../utils";
import { toast } from "react-toastify";
import { IFileUpload } from "./FileUpload.type";
import Field from "../field";

const FileUpload: FC<IFileUpload> = ({ recordID, accept = '', isMulti, value, setValue, type, label, className, placeHolderName }) => {
  const { t } = useTranslation();

  const AllowedExtentions = useMemo(() => accept?.split(','), [accept])

  const handleFileValue = (targetObject: any) => {
    let files = Object.entries(targetObject?.files).map(([key, data]) => data)

    if (files.some(file => !validateUploadedFile(file, AllowedExtentions))) return toast.error(`${t('availble-formates')} ${accept}`)

    setValue(files)
  }


  return (
    <>
      <div className={`file-upload-container  ${className}`}>
        <div className="custom-file-upload">
          <label
            htmlFor={`File_${recordID}_${label}_${type}`}
            className={`upload-File ${className}`}
          >
            {!value ?
              <>
                <Icon icon="mage:file-upload" className="upload-icon" width="24" height="24" />

                <div> {t("drop File")}</div>
                <div className="file-upload-note">
                  {t(placeHolderName || "")}
                </div>
              </>
              :
              <div className="file-upload-note">
                {value?.name}
              </div>
            }
          </label>
        </div>

        <Field isMulti={isMulti} setValue={handleFileValue} type={"file"} accept={accept} className={"d-none"} id={`File_${recordID}_${label}_${type}`} />
      </div>
    </>
  );
};

export default FileUpload;
